import ApolloClient from 'apollo-boost';

export const apolloClient = new ApolloClient({
  uri: 'https://xchematic-store.myshopify.com/api/2020-04/graphql.json',
  headers: {
    'X-Shopify-Storefront-Access-Token': '7010f8ebf13918ecfb734f181889689c'
  }
});